export const STATUSES = {
  DRAFT: 'draft',
  PUBLISHED: 'published',
};

export enum SHOW_TYPES {
  ALWAYS = 'always',
  HOVER = 'hover',
  NEVER = 'never',
}

export enum APPEAREANCES {
  FULL_BLEED = 'full-bleed',
  CONTAINED = 'contained',
  FULL_WIDTH = 'full-width',
}

export enum COLLAGES {
  POSTER = 'poster',
  LEFT = 'collage-left',
  CENTER = 'collage-centered',
  RIGHT = 'collage-right',
}

export enum BUTTONS_APPEARANCE {
  STACKED = 'stacked',
  INLINE = 'inline',
}
